import React from "react";
import { Manager, Reference } from "react-popper";

import { StyledIconWrapper, getInlineIconImageClassName } from "./styles";
import { InlineIconConfig } from "./DefaultConfig";
import type { ViewerDeviceRuntime } from "../../../../../types";
import { resolveImageUrlForDevice } from "../../../../../util/resolveOfflinePackageImageUrl";
import { resolveInlineIconSizeCode } from "./utils";

type IconBoxProps = {
  metadata: InlineIconConfig;
  viewerDevice?: ViewerDeviceRuntime;
};

const IconBox: React.FC<IconBoxProps> = ({ metadata, viewerDevice }) => {
  const { url, size, cssClass, alt = "" } = metadata;
  const resolvedUrl = resolveImageUrlForDevice(url, viewerDevice);
  const sizeCode = resolveInlineIconSizeCode(size);

  return (
    <Manager>
      <Reference>
        {({ ref }) => (
          <StyledIconWrapper ref={ref} className={cssClass}>
            <img className={getInlineIconImageClassName(sizeCode)} src={resolvedUrl} alt={alt} />
          </StyledIconWrapper>
        )}
      </Reference>
    </Manager>
  );
};

export default IconBox;
